const Intent = `package spacelift

# 🦕 Feel free to remove commented code once your policy is ready. 🦕
#
#
# Intent policy allows you to configure intent-based authentication.
# It receives a JSON document which fields differ depending on the intent type.
# By checking the set values you're able to determine the intent type and take appropriate actions.

`;

export default Intent;
